import api from '../../services/api'
import { addErrorToast, addDeleteToast, addSaveToast } from './companyActionCreators'
import {
    EMAIL_REPORT_LOADING,
    EMAIL_REPORT_EDIT_LOADED,
    EMAIL_REPORT_COMPANIES_LOADED,
    EMAIL_REPORT_NEW_COMPANY_SELECTED,
    EMAIL_ALL_COMPANIES_LOADED,
    EMAIL_ALL_COMPANIES_LOADING,
} from './emailReportsTypes'
import { handleReportLoading } from './reportsActions'
import { push } from 'connected-react-router'

export const handleEmailReportLoading = () => {
    return {
        type: EMAIL_REPORT_LOADING,
    }
}

export const handleEmailReportCompaniesLoaded = (payload) => {
    return {
        type: EMAIL_REPORT_COMPANIES_LOADED,
        payload: payload,
    }
}

export const handleCompanyListLoading = () => {
    return {
        type: EMAIL_ALL_COMPANIES_LOADING,
    }
}

export const handleCompanyListLoaded = (payload) => {
    return {
        type: EMAIL_ALL_COMPANIES_LOADED,
        payload: payload,
    }
}

export const handleCompanySelectedEmailReport = (payload) => {
    return {
        type: EMAIL_REPORT_NEW_COMPANY_SELECTED,
        payload: payload,
    }
}

export const handleExistingDataLoaded = (payload) => {
    return {
        type: EMAIL_REPORT_EDIT_LOADED,
        payload: payload,
    }
}
export const fetchEmailReportList = () => async (dispatch) => {
    dispatch(handleReportLoading())

    try {
        const res = await api.get(`/emailReport/reports`)
        const data = await res.json()
        dispatch(handleEmailReportCompaniesLoaded(data))
    } catch (e) { }
}

export const fetchEmailCompanyList = (id) => async (dispatch) => {
    dispatch(handleCompanyListLoading())
    try {
        if (id !== null) {
            var saved = await api.get(`/emailReport/report/${id}`)
            if (saved.ok) {
                const savedData = await saved.json()
                const companies = await api.get(`/emailReport/companies`)
                const companiesData = await companies.json()
                dispatch(handleExistingDataLoaded({ savedData: savedData, companiesData: companiesData }))
            }
        } else {
            const res = await api.get(`/emailReport/companies`)
            const data = await res.json()
            dispatch(handleCompanyListLoaded(data))
        }
    } catch (e) { }
}

export const handleSubmitSaveEmailReportEntry = (values) => async (dispatch) => {
    dispatch(handleEmailReportLoading())
    try {
        const res = await api.post(`/emailReport/edit`, {
            id: values.id,
            companyId: values.selectedCompany.value,
            start: values.startDate,
            dayOfMonth: values.selectedDayOfMonth.value,
            includeAdditionExclusions: values.includeExcluded,
            includeInactiveUsers: values.includeInactive,
            includeIgnoredUsers: values.includeIgnored,
            includeVeeamReports: values.includeVeeamReports,
            recipients: values.emailAddresses,
        })

        if (res.ok) {
            dispatch(addSaveToast('report'))
            dispatch(push(`/emailReport`))
        } else {
            dispatch(addErrorToast(res.status))
            throw await res.text()
        }
    } catch (e) {
        dispatch(addErrorToast(e))
        throw e
    }
}
export const handleSubmitCreateEmailReportEntry = (values) => async (dispatch) => {
    dispatch(handleEmailReportLoading())

    try {
        const res = await api.post(`/emailReport/add`, {
            companyId: values.selectedCompany.value,
            start: values.startDate,
            dayOfMonth: values.selectedDayOfMonth.value,
            includeAdditionExclusions: values.includeExcluded,
            includeInactiveUsers: values.includeInactive,
            includeIgnoredUsers: values.includeIgnored,
            includeVeeamReports: values.includeVeeamReports,
            recipients: values.emailAddresses,
        })

        if (res.ok) {
            dispatch(addSaveToast('report'))
            dispatch(push(`/emailReport`))
        } else {
            dispatch(addErrorToast(res.status))
            throw await res.text()
        }
    } catch (e) {
        dispatch(addErrorToast(e))
        throw e
    }
}

export const handleDeleteReport = (id) => async (dispatch) => {
    dispatch(handleEmailReportLoading())

    try {
        const res = await api.deleteCall(`/EmailReport/${id}`)
        if (res.ok) {
            dispatch(addDeleteToast('report'))
            dispatch(fetchEmailReportList())
        } else {
            dispatch(addErrorToast('deleteReport'))
        }
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}

export const handleGenerateReport = (id) => async (dispatch) => {
    dispatch(handleEmailReportLoading())

    try {
        const res = await api.post(`/EmailReport/Generate/${id}`)
        if (res.ok) {
            dispatch(addSaveToast('report'))
            dispatch(fetchEmailReportList())
        } else {
            dispatch(addErrorToast('generateReport'))
        }
    } catch (e) {
        dispatch(addErrorToast(e))
    }
}